//accordion
//TODO: allow open/close btns to only affect a group
export default class Accordion {
    constructor(_options = {}) {
        this.defaults = {
            accordionContainerId: 'js-faq',
            accordionButtonClass: 'js-button',
            accordionPanelClass: 'js-panel',
            useOpenCloseBtns: false,
            openBtnClass: 'js-open-all',
            closeBtnClass: 'js-close-all'
        };
    
        this.settings = Object.assign({}, this.defaults, _options);

        this.accordionBtn = document.getElementById(this.settings.accordionContainerId).getElementsByClassName(this.settings.accordionButtonClass);

        for (let i = 0, length = this.accordionBtn.length|0; i < length; i++) {

            this.setAccordion(this.accordionBtn[i], false);

            this.accordionBtn[i].addEventListener("click", (el) => {
                this.toggleAccordion(el.target);
            });
        }

        if (this.settings.useOpenCloseBtns) {
            let openBtns = document.getElementsByClassName(this.settings.openBtnClass);
            let closeBtns = document.getElementsByClassName(this.settings.closeBtnClass);

            for (let i = 0, length = openBtns.length; i < length; i++ ) {
                openBtns[i].addEventListener('click', (el) => {
                    this.openAll(el.target);
                });
            }

            for (let i = 0, length = closeBtns.length; i < length; i++ ) {
                closeBtns[i].addEventListener('click', (el) => {
                    this.closeAll(el.target);
                });
            }
        }
    }

    closeAll(el) {
        for (let i = 0, length = this.accordionBtn.length|0; i < length; i++) {
            this.setAccordion(this.accordionBtn[i], false);
        }
    }

    openAll(el) {
        for (let i = 0, length = this.accordionBtn.length|0; i < length; i++) {
            this.setAccordion(this.accordionBtn[i], true);
        }

    }

    setAccordion(el, show) {
        let panelId = el.getAttribute('aria-controls');
        
        //get panel element
        let panelEl = document.getElementById(panelId);

        //set aria attributes and show/hide panel
        panelEl.setAttribute('hidden', !show);
        el.setAttribute('aria-expanded', show);
    }

    toggleAccordion(el) {
        let show = el.getAttribute('aria-expanded') === 'true' || false
        this.setAccordion(el, !show);
    }
}